import { Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import CheckoutArea from 'src/checkout-area/checkout-area';
import { AppState } from 'src/common/redux/configure-store';
import MiddleAreaWrapper from 'src/middle-area/wrapper/middle-area-wrapper';
import SizedGridItem from 'src/sized-grid-item/sized-grid-item';
import { styles } from './home-page-tendering-styles';
import { updateScannerCallback } from 'src/devices/scanner-operations';
import { onAddItemDataScanned } from '../business-logic/submit-scanned-data';
import { useResponsiveContext } from '../hooks/responsive-context';

const HomePageSale = (): JSX.Element => {
  const isLeftHanded = useSelector<AppState, boolean>(state => state.cashierPreferences.leftHanded);
  const { showSidebar } = useResponsiveContext();
  const classes = styles({ leftHanded: isLeftHanded });
  useEffect((): void => {
    updateScannerCallback(onAddItemDataScanned);
  }, []);

  return (
    <Grid container wrap='nowrap' direction={isLeftHanded ? 'row-reverse' : 'row'}>
      <Grid
        item
        className={`fullHeight ${
          !showSidebar ? classes.itemListContainerSmallForm : classes.itemListContainer
        }`}
      >
        <CheckoutArea />
      </Grid>
      {/* Middle Area w/ the tabs - the width 0 is a hack otherwise it pushes content around */}
      <Grid item className={`fullHeight flexFull ${classes.middleArea}`}>
        <Grid container direction='column' className={`fullHeight fullWidth`}>
          <SizedGridItem size='auto' className={`fullWidth fullHeight`}>
            <MiddleAreaWrapper />
          </SizedGridItem>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default HomePageSale;
